import {
  actionColumn,
  actionsColumn,
  checkAmountColumn,
  checkNumberColumn,
  dcColumn,
  dcNameColumn,
  DeductionTableColumn,
  discountAmountColumn,
  customerColumn,
  filesColumn,
  backupParseColumn,
  invoiceNumberColumn,
  lastTouchedAtColumn,
  paymentDaysColumn,
  statusColumn,
  taskColumn,
  selectColumn,
} from "@/deduction_table/columns"
import { createDateColumn } from "@/deduction_table/date_column"
import { defaultFilter } from "@/utils/filters.ts"
import { ColumnHeader } from "@/deduction_table/column_header"

// Inline poNumberColumn to avoid circular dependency
const poNumberColumn: DeductionTableColumn = {
  accessorKey: "po_number",
  header: ({ column }) => <ColumnHeader column={column} title="PO " />,
  enableSorting: true,
  filterFn: defaultFilter,
}

export const INVOICE_COLUMNS_WITHOUT_BACKUP_PARSE: DeductionTableColumn[] = [
  selectColumn,
  createDateColumn("invoice_date", "Invoice Date"),
  invoiceNumberColumn,
  // invoiceAmountColumn,
  customerColumn,
  filesColumn,
  discountAmountColumn,
  createDateColumn("check_date", "Check Date", { enableGlobalFilter: true, enableHiding: true }),
  createDateColumn("payment_due_date", "Payment Due Date", {
    enableGlobalFilter: true,
    enableHiding: true,
  }),
  paymentDaysColumn,
  checkNumberColumn,
  checkAmountColumn,
  statusColumn,
  actionColumn,
  actionsColumn,
  poNumberColumn,
  taskColumn,
  dcColumn,
  dcNameColumn,
  {
    accessorKey: "validated",
    enableHiding: true,
  },
  lastTouchedAtColumn,
  //   todo: difference between check date and invoice date in days or is that not the payment date??
]

export const INVOICE_COLUMNS: DeductionTableColumn[] = [...INVOICE_COLUMNS_WITHOUT_BACKUP_PARSE, backupParseColumn]
